import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Observable} from 'rxjs';
import {Router} from "@angular/router";
import {CookieService} from "@iw-shop/core/services/cookie.service";
import {isPlatformBrowser} from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    private readonly isBrowser: boolean;
    private dynamicEnv: any;

    constructor(private route: Router, protected cookieService: CookieService, @Inject(PLATFORM_ID) platformId: Object) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    /** Setter for environment variable */
    setEnvironment(env: {urlApi: string, urlS3: string}) {

        this.dynamicEnv = env;
/*        env.subscribe(data =>
            this.dynamicEnv = {...data}
        );*/
        if (this.isBrowser &&
            this.cookieService.getCookie('config')) {
            this.dynamicEnv.urlApi = './api/' + this.cookieService.getCookie('config') + '/';
        }
    }

    /** Getter for environment variable */
    get environment() {
        return this.dynamicEnv;
    }
}
